import { RenderClient } from 'src/components/RenderClient'
// import TrustPilotWidget from 'src/components/ui/TrustPilotWidget/TrustPilotWidget'
import { Suspense, lazy } from 'react'
import widgetSettings from 'src/components/ui/TrustPilotWidget/widgetSettings'

import './trust-pilot-box.scss'
import type { TrustPilotBox, TrustPilotBoxProps } from './trustpilot-box'

const TrustPilotWidget = lazy(
  () => import('src/components/ui/TrustPilotWidget/TrustPilotWidget')
)

function TrustPilotBoxComponent({
  trustPilotBoxProperties,
}: TrustPilotBoxProps) {
  const trustPilotArray = trustPilotBoxProperties ?? []

  return (
    <div className="trustPilot-widget-container">
      {trustPilotArray?.map((element: TrustPilotBox, index: number) => {
        return (
          <Suspense fallback={null} key={index}>
            <RenderClient>
              <TrustPilotWidget
                widgetSettings={widgetSettings.getWidgetSettings(
                  element?.widtgetType
                )}
                gtin={element?.productReferenceId}
                productName={element?.productName}
                marginTop={`${element?.marginTop ?? '0px'}`}
                marginBottom={`${element?.marginBottom ?? '0px'}`}
              />
            </RenderClient>
          </Suspense>
        )
      })}
    </div>
  )
}

export default TrustPilotBoxComponent
